import request from '@/utils/request'

export const login = (data) => {
  return request({
    url: '/erp/index/login',
    method: 'post',
    data
  })
}

export const codeLogin = (data) => {
  return request({
    url: '/erp/index/login-mobile',
    method: 'post',
    data
  })
}

// 退出登录
export const logout = () => {
  return request({
    url: '/erp/index/logout',
    method: 'get'
  })
}




// 重置密码
export const forgetPassword=(data)=>{
  return request({
    url: '/erp/index/up-pwd',
    method: 'post',
    data
  })
}

// 用户注册
export const userRegister=(data)=>{
  return request({
    url: '/erp/index/register',
    method: 'post',
    data
  })
}


// 重置密码
export const resetPassword=(data)=>{
  return request({
    url: '/erp/index/up-pwd',
    method: 'post',
    data
  })
}


// 发送验证码
export const sendCode = (data) => {
  return request({
    url: '/erp/index/sms-code',
    method: 'post',
    data
  })
}
